﻿import HotEditableFormManager_ from "./HotEditableFormManager";
import common from "../../../common";
import DefaultEdit from "../../components/DefaultEdit";

// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;

class FormNode {

    private _formManager: HotEditableFormManager_;
    private _parentNode?: FormNode;
    private _childrenNodes = [] as FormNode[];
    private _innerWebComponent = null as common.IWebComponent | null;
    private _innerWebComponentUrl = null as string | null;
    /** le parent dans le cas dune imbrication */

    /** Nom du champ qui contient this. Est top parent si NULL */
    private _containerName? = null as string | null;

    constructor(currentFormManager: HotEditableFormManager_) {
        this._formManager = currentFormManager;
    }

    isTopParent() { return !this._parentNode; }
    setParent(parent: FormNode) {
        this._parentNode = parent;
        return this;
    }
    containerFieldNameIs(name: string) { return !!this._containerName && this._containerName === name; }
    getContainerName() { return this._containerName; }
    getInnerWebComponentUrl() { return this._innerWebComponentUrl ?? null; }
    onRegister(containerName: string | null, url: string | null, innerWebComponent: common.IWebComponent) {
        this._containerName = containerName ?? (() => { throw "Container field name cannot be null." })();
        this._innerWebComponent = innerWebComponent ?? null;
        this._innerWebComponentUrl = url ?? null;
        return this;
    }
    removeChild(node: FormNode) {
        const r = [] as FormNode[];
        this._childrenNodes?.forEach(x => {
            if (x._containerName !== node._containerName)
                r.push(x);
        });
        this._childrenNodes = r;
    }
    private destroyChildren() {
        if (this._childrenNodes)
            for (let i = 0; i < this._childrenNodes.length; i++) {
                const x = this._childrenNodes[i];
                if (x) {
                    x.destroyComponents();
                    if (x._formManager?.formNode)
                        x._formManager.formNode = null;
                }
            }
        this._childrenNodes = [];
        return this;
    }
    destroyComponents() {
        this.destroyChildren();
        this._formManager.destroyComponents();
        if (this._parentNode)
            this._parentNode.removeChild(this);
    }
    registerChildNode(childNode?: FormNode | null) {
        if (childNode)
            this._childrenNodes.push(childNode.setParent(this));
        return this;
    }
    /** RoutingTOP or Current */
    containsHotEmbeddedComponent(name: string): boolean {
        return this.isTopParent()
            ? this._currentContainsEmbeddedComponent(name)
            : this._parentNode?.containsHotEmbeddedComponent(name) ?? false;
    }
    // /** RoutingTOP or Current */
    // containsHotEmbeddedComponents(embeddedComponents: common.IHotEditableEmbeddedComponent[], purgeChildren?: boolean): boolean {
    //     purgeChildren = purgeChildren === true;
    //     return this.isTopParent()
    //         ? this._currentContainsEmbeddedComponent(name)
    //         : this._parentNode.containsHotEmbeddedComponent(name);
    // }
    /** RoutingTOP or Current */
    findHotEmbeddedComponent(name?: string | null): common.IHotEditableEmbeddedComponent | null {
        return this.isTopParent()
            ? this._getCurrentEmbeddedComponent(name)
            : this._parentNode?.findHotEmbeddedComponent(name) ?? null;
    }
    /** RoutingTOP or Current */
    updateHotEmbeddedComponent(name?: string | null, nextUrl?: string | null, urlParameters?: any | null, editModeOn?: boolean, finalEvalCallback?: (() => void) | null): boolean {
        return this.isTopParent()
            ? this._updateCurrentHotEmbeddedComponent(name, nextUrl, urlParameters, editModeOn, finalEvalCallback)
            : this._parentNode?.updateHotEmbeddedComponent(name, nextUrl, urlParameters, editModeOn, finalEvalCallback) ?? false;
    }
    /** Current or RoutingDOWN. */
    private _updateCurrentHotEmbeddedComponent(name?: string | null, nextUrl?: string | null, urlParameters?: any | null, editModeOn?: boolean, finalEvalCallback?: (() => void) | null) {
        return this._formManager.updateHotEmbeddedComponent(name, nextUrl, urlParameters, editModeOn, finalEvalCallback) || this._updateChildrenEmbeddedComponent(name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
    }
    /** Current or RoutingDOWN */
    private _currentContainsEmbeddedComponent(name: string) {
        return this._formManager.containsHotEmbeddedComponent(name) || this._childrenContainsEmbeddedComponent(name);
    }
    /** Current or RoutingDOWN */
    private _getCurrentEmbeddedComponent(name?: string | null) {
        return this._formManager.getHotEmbeddedComponent(name) ?? this._getChildrenEmbeddedComponent(name);
    }
    /** Children */
    private _updateChildrenEmbeddedComponent(name?: string | null, nextUrl?: string | null, urlParameters?: {} | null, editModeOn?: boolean, finalEvalCallback?: (() => void) | null) {
        const first = this._getFirstChildrenNode(child => child._updateCurrentHotEmbeddedComponent(name, nextUrl, urlParameters, editModeOn, finalEvalCallback));
        return !!first;
    }
    /** Children */
    private _childrenContainsEmbeddedComponent(name: string): boolean {
        return !!this._getChildNodeByName(name);
    }
    private _getChildrenEmbeddedComponent(name?: string | null) {
        if (this._childrenNodes)
            for (let i = 0; i < this._childrenNodes.length; i++) {
                const node = this._childrenNodes[i];
                const c = node._formManager.getHotEmbeddedComponent(name);
                if (c)
                    return c;
            }
        return null;
    }
    /** Children */
    private _getChildNodeByName(name: string) {
        return this._getFirstChildrenNode(child => child._currentContainsEmbeddedComponent(name));
    }
    /** Retournera le premier enfant dont l'action renvera TRUE, sinon retournera NULL. */
    private _getFirstChildrenNode(where: (node: FormNode) => boolean) {
        if (this._childrenNodes)
            for (let i = 0; i < this._childrenNodes.length; i++) {
                const node = this._childrenNodes[i];
                if (where(node) === true)
                    return node;
            }
        return null;
    }

    getHotEmbeddedComponentByNameFromParent(name?: string | null) {
        return this._parentNode?._formManager.getHotEmbeddedComponentByName(name);
    }
    refreshBrotherEmbeddedComponents(currentEmbeddedComponentName: string) {
        this._parentNode?.refreshBrotherEmbeddedComponents(currentEmbeddedComponentName);
        return this;
    }
    isParentOf(componentName?: string | null): boolean {
        if (this._containerName === componentName)
            return true;
        if (!this._parentNode)
            return false;
        return this.isParentOf(this._containerName) === true;
    }
    hasParent(componentName: string | null): boolean {
        if (!this._parentNode)
            return false;
        if (this._parentNode._containerName === componentName)
            return true;
        return this._parentNode.hasParent(componentName);
    }
    hasEditionEmbeddedForm() {
        if (this._parentNode?.hasEditionEmbeddedForm())
            return true;
        for (let i = 0; i < this._childrenNodes.length; i++)
            if (this._childrenNodes[i].hasEditionEmbeddedForm())
                return true;
        if (this._parentNode && this._parentNode.hasEditionEmbeddedForm())
            return true;
        return false;
    }
    getEmbeddedContentModels(clause?: (model: common.IEmbeddedContentModel) => boolean): common.IEmbeddedContentModel | null {
        return this._parentNode?.getEmbeddedContentModels(clause) ?? null;
    }
    showHotEmbeddedComponentsByCategory(category: string, isVisible?: boolean) {
        this._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        for (let i = 0; i < this._childrenNodes.length; i++)
            this._childrenNodes[i]._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        return this;
    }
    private _innerShowHotEmbeddedComponentsByCategory(category: string, isVisible?: boolean) {
        if (this._parentNode)
            this._parentNode._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        this._parentNode?._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
    }
    countHotEmbeddedComponentsByCategory(category: string) {
        var count = this._innerCountHotEmbeddedComponentsByCategory(category);
        for (let i = 0; i < this._childrenNodes.length; i++)
            count += this._childrenNodes[i]._innerCountHotEmbeddedComponentsByCategory(category);
        return count;
    }
    private _innerCountHotEmbeddedComponentsByCategory(category: string) {
        var count = (this._parentNode?._innerCountHotEmbeddedComponentsByCategory(category) ?? 0) as number;
        if (this._parentNode)
            count += this._parentNode._innerCountHotEmbeddedComponentsByCategory(category);
        return count;
    }

    getTopParent(): FormNode | null {
        if (this.isTopParent())
            return this;
        return this._parentNode?.getTopParent() ?? null;
    }

    drawTree() {
        console.log("Drawing tree nodes...");
        const root = this.getTopParent();
        if (!root)
            throw new Error("No top parent found");

        FormNode._drawTree(root ?? this);
    }

    private static _drawTree(formNode: FormNode, level: number = 0) {
        if (!formNode) {
            console.warn("No form node.");
            return;
        }
        const name = (formNode._containerName ?? "(undefined)") +
            " [" +
            "formName: " + (formNode._formManager.getFormName() ?? "(undefined)") +
            ", act: " + (formNode.getInnerWebComponentUrl()?.split("?")[0] ?? "(undefined)") +
            ", api: " + ((formNode._innerWebComponent as any)?.getApiUrl ? (formNode._innerWebComponent as any)?.getApiUrl()?.split("?")[0] ?? "(undefined)" : "(not implemnenting 'getApiUrl' method)") +
            "]";
        var indent = "";
        for (let i = 0; i <= level; i++)
            indent += "  ";
        if (level)
            console.log(indent + level + "> child: " + name);
        else
            console.log(level + "> root: " + name);
        formNode._childrenNodes.forEach(x => {
            FormNode._drawTree(x, level + 1);
        });
    }
}

export = FormNode;